import { lazyRetry } from '@bimser/core';
import React, { lazy, Suspense } from 'react';
import { IIconFinderProps } from './entities';
import { IconFinderRef } from './entities/IconFinderRef';

const BCIconFinderLazy = lazy(() =>
	lazyRetry(() => import(/* webpackChunkName: "icon-finder" */ './components/IconFinder'))
);

const BCIconFinder = React.forwardRef(
	(props: IIconFinderProps, ref: React.ForwardedRef<IconFinderRef>) => {
		return (
			<Suspense fallback={<div></div>}>
				<BCIconFinderLazy
					{...props}
					ref={ref}
				/>
			</Suspense>
		);
	}
);

export { BCIconFinder, IconFinderRef };
